import { presetsFor, type BetPreset } from "../engine/betPresets.js";

interface BetControlsProps {
  presetCtx: Parameters<typeof presetsFor>[0];
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
}

/**
 * Bet-size preset row. The numeric stepper that used to share this row was
 * removed (2026-07-17 フィードバック #3) -- the amount input now lives in
 * the hero's `PlayerPanel` (see `BetAmountInput`), and this row alone was
 * shrunk (smaller padding/font) to free up vertical room for taller action
 * buttons below it.
 */
export function BetControls({ presetCtx, min, max, value, onChange }: BetControlsProps) {
  const presets = presetsFor(presetCtx, min, max);

  return (
    <div className="bet-controls">
      <div className="bet-preset-row">
        {presets.map((p: BetPreset) => (
          <button
            key={p.label}
            type="button"
            className={`bet-preset ${value === p.toChips ? "bet-preset-selected" : ""} ${
              p.label === "All-in" ? "bet-preset-allin" : ""
            }`}
            onClick={() => onChange(p.toChips)}
          >
            {p.label}
          </button>
        ))}
      </div>
    </div>
  );
}
